import styled from 'styled-components';

import Admin from 'hive-admin/src/components/Admin';
import FieldTextArea, {
  InputTextArea,
} from 'hive-admin/src/components/FieldTextArea';

// eslint-disable-next-line max-len, import/prefer-default-export
export const InputTextAreaMonospace = styled(InputTextArea)`
  font-family: ${({ theme }) => theme.monospaceFontStack};
`;

Admin.addToLibrary(
  'FieldTextAreaMonospace',
  (config = {}) => FieldTextArea.create({
    ...config,
    Component: InputTextAreaMonospace,
  }),
);
